import React, { useEffect } from 'react';
import postSignature from '../../../apis/postSignature';

// components
import Title from '../../../components/Title';
import Button from '../../../components/Button';

// assets
import SelfieIndication from '../../../assets/img/SelfieIndication.png';
import { useStore } from '../../../context/appContext';
import { modalTypes } from '../../../context/types';
import useGAEventsTracker from '../../../utils/useGAEventsTrackers';
import { CAMERA_ACCESS_ERROR, selfieTypes, SPECIAL_SELFIE } from '../../../constants/selfieTypes';
import {
  Bluespan,
  ButtonDiv,
  ContentDiv,
  DescriptionText,
  ImagePreview,
  Img,
  MainCameraDiv,
  SelfieIndicationDiv,
  SelfieText
} from './signatureStyled';

function SignatureSpecial() {
  const {
    setModal,
    photosUri,
    setLoading,
    setCamera,
    user,
    contracts,
    notificate,
    setError
  } = useStore();

  const constraints = { audio: false, video: { facingMode: 'environment', width: 720, height: 1080 } }
  const cameraError = { type: CAMERA_ACCESS_ERROR }

  const GAEventsTracker = useGAEventsTracker("Selfie Special Page");
  useEffect(() => {
    GAEventsTracker("Visualiza pantalla Selfie con Gesto");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (photosUri.specialSelfie) return;
    setModal({
      open: true,
      type: modalTypes.selfieSpecialInfo,
    });
    return () => {
      setModal({
        open: false,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = () => {
    if (!photosUri.specialSelfie) return;
    GAEventsTracker("Confirma selfie con gesto");
    GAEventsTracker("Confirma envio de fotos");
    setLoading(true);
    const allSelfies = {
      selfie1: {
        photo: photosUri.neutralSelfie,
        type: 'SN'
      },
      selfie2: {
        photo: photosUri.specialSelfie,
        type: selfieTypes[photosUri.randomSelfie].type
      }
    }
    postSignature(
      user,
      photosUri,
      contracts.dataUrl,
      notificate,
      allSelfies,
      setError)
      .then((data) => {
        GAEventsTracker("Validacion biometrica OK");
        setModal({ open: true, type: modalTypes.signatureSuccess })
        setLoading(false);
      })
      .catch((error) => {
        GAEventsTracker("Validacion biometrica Error");
        setLoading(false);
        setModal({
          open: true,
          type: modalTypes.signatureRetry,
          message: error.message,
        });
        photosUri.neutralSelfie = null;
        photosUri.specialSelfie = null;
      });
  };

  const cameraPermissions = (type) => {
    setCamera({
      open: true,
      type: type,
    });
  }

  const handleOpenCamera = () => {
    cameraPermissions(SPECIAL_SELFIE);
    // setCamera({
    //   open: true,
    //   type: SPECIAL_SELFIE,
    // });
  };

  return (
    <>
      <Title grid="title">Firma electrónica</Title>
      <ContentDiv>
        <DescriptionText>
          Ahora necesitamos que te tomes una <b>'{selfieTypes[photosUri.randomSelfie].input}'</b> para completar el proceso
        </DescriptionText>
        <MainCameraDiv>
          <SelfieIndicationDiv onClick={handleOpenCamera}>
            {photosUri.specialSelfie ? (
              <ImagePreview src={photosUri.specialSelfie} />
            ) : (
              <>
                <Img src={SelfieIndication} />
                <SelfieText>
                  <Bluespan>Presiona áca</Bluespan> para tomar una foto de{' '}
                  <Bluespan>tu rostro</Bluespan>
                </SelfieText>
              </>
            )}
          </SelfieIndicationDiv>
        </MainCameraDiv>
      </ContentDiv>
      <ButtonDiv>
        <Button filled={!!photosUri.specialSelfie} onClick={handleSubmit}>
          Confirmar
        </Button>
      </ButtonDiv>
    </>
  );
}

export default SignatureSpecial;
